import { createAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { Column } from '../grid/experimental.grid';

export interface FocusSelectorSortMetrics {
    column: Column;
}

export const focusSelectorSortMetrics = createAction<
    ActionType,
    FocusSelectorSortMetrics
>(ActionType.COACHING_FOCUS_SELECTOR__SORT_METRICS);
